// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  padding: 5px 5px 15px;
  max-width: 1800px;
  margin: 0 auto;
  width: 100%;
}

h2 {
  margin: 0 0 15px;
  color: #3f51b5;
}

.layout-container {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  width: 100%;
}

.form-container {
  padding: 15px 20px;
  border-radius: 4px;
  flex: 0.6;
  min-width: 280px;
  max-width: 320px;
}

.form-row {
  margin-bottom: 15px;
}

.form-row mat-form-field {
  width: 100%;
}

/* Style for mat-select dropdown panel to show full title */
::ng-deep .mat-select-panel {
  min-width: 400px !important;
  max-width: 500px !important;
}

::ng-deep .mat-option-text {
  white-space: normal !important;
  line-height: 1.2em !important;
  padding: 8px 0 !important;
}

::ng-deep .full-width-select .mat-select-trigger {
  white-space: normal !important;
  line-height: 1.2em !important;
}

::ng-deep .full-width-option {
  height: auto !important;
  line-height: 1.2em !important;
  padding: 8px 16px !important;
}

.form-actions {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.error-message {
  color: #f44336;
  margin-top: 15px;
}

.table-container {
  position: relative;
  min-height: 400px;
  overflow: auto;
  flex: 5;
  min-width: 850px;
}

/* When form is not shown (non-admin users), make table take full width */
.layout-container.full-width .table-container {
  flex: 1;
  width: 100%;
}

.table-loading-shade {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.15);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.table-header {
  padding: 10px 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
}

.table-header mat-form-field {
  flex: 1;
}

.header-actions {
  flex-shrink: 0;
}

table {
  width: 100%;
}

.mat-column-id {
  width: 80px;
}

.mat-column-actions {
  width: 120px;
  text-align: center;
}

tr.mat-row:hover {
  background-color: #f5f5f5;
}

/* Expanded detail row styles */
.detail-row {
  height: auto;
  background-color: #f8f8f8;
}

.expanded-detail {
  overflow: hidden;
  padding: 20px;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
}

/* Table styles */
.table {
  width: 100%;
  border-collapse: collapse;
}

/* Role title column styling */
.role-title {
  cursor: pointer;
  font-weight: 500;
  color: #3f51b5;
  position: relative;
}

.role-title:hover {
  text-decoration: underline;
}

.role-title::after {
  content: '\\25BC';
  font-size: 10px;
  margin-left: 5px;
  color: #757575;
  transition: transform 0.2s;
}

.expanded .role-title::after {
  transform: rotate(180deg);
}

.table th {
  background-color: #f5f5f5;
  padding: 12px 8px;
  text-align: left;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.table td {
  padding: 12px 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.table tr:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.table tr.detail-row:hover {
  background-color: #f8f8f8;
}

@media (max-width: 1024px) {
  .layout-container {
    flex-direction: column;
  }
  
  .form-container, .table-container {
    width: 100%;
    min-width: unset;
  }
  
  .form-container {
    margin-bottom: 30px;
  }
  
  .mat-column-id {
    width: 50px;
  }
  
  .mat-column-actions {
    width: 100px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/role-assignment/role-assignment.component.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA,2DAA2D;AAC3D;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,OAAO;EACP,gBAAgB;AAClB;;AAEA,yEAAyE;AACzE;EACE,OAAO;EACP,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,+BAA+B;EAC/B,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".container {\n  padding: 5px 5px 15px;\n  max-width: 1800px;\n  margin: 0 auto;\n  width: 100%;\n}\n\nh2 {\n  margin: 0 0 15px;\n  color: #3f51b5;\n}\n\n.layout-container {\n  display: flex;\n  gap: 15px;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.form-container {\n  padding: 15px 20px;\n  border-radius: 4px;\n  flex: 0.6;\n  min-width: 280px;\n  max-width: 320px;\n}\n\n.form-row {\n  margin-bottom: 15px;\n}\n\n.form-row mat-form-field {\n  width: 100%;\n}\n\n/* Style for mat-select dropdown panel to show full title */\n::ng-deep .mat-select-panel {\n  min-width: 400px !important;\n  max-width: 500px !important;\n}\n\n::ng-deep .mat-option-text {\n  white-space: normal !important;\n  line-height: 1.2em !important;\n  padding: 8px 0 !important;\n}\n\n::ng-deep .full-width-select .mat-select-trigger {\n  white-space: normal !important;\n  line-height: 1.2em !important;\n}\n\n::ng-deep .full-width-option {\n  height: auto !important;\n  line-height: 1.2em !important;\n  padding: 8px 16px !important;\n}\n\n.form-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.error-message {\n  color: #f44336;\n  margin-top: 15px;\n}\n\n.table-container {\n  position: relative;\n  min-height: 400px;\n  overflow: auto;\n  flex: 5;\n  min-width: 850px;\n}\n\n/* When form is not shown (non-admin users), make table take full width */\n.layout-container.full-width .table-container {\n  flex: 1;\n  width: 100%;\n}\n\n.table-loading-shade {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.15);\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.table-header {\n  padding: 10px 20px 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 15px;\n}\n\n.table-header mat-form-field {\n  flex: 1;\n}\n\n.header-actions {\n  flex-shrink: 0;\n}\n\ntable {\n  width: 100%;\n}\n\n.mat-column-id {\n  width: 80px;\n}\n\n.mat-column-actions {\n  width: 120px;\n  text-align: center;\n}\n\ntr.mat-row:hover {\n  background-color: #f5f5f5;\n}\n\n/* Expanded detail row styles */\n.detail-row {\n  height: auto;\n  background-color: #f8f8f8;\n}\n\n.expanded-detail {\n  overflow: hidden;\n  padding: 20px;\n  border-top: 1px solid #e0e0e0;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n/* Table styles */\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n/* Role title column styling */\n.role-title {\n  cursor: pointer;\n  font-weight: 500;\n  color: #3f51b5;\n  position: relative;\n}\n\n.role-title:hover {\n  text-decoration: underline;\n}\n\n.role-title::after {\n  content: '\\25BC';\n  font-size: 10px;\n  margin-left: 5px;\n  color: #757575;\n  transition: transform 0.2s;\n}\n\n.expanded .role-title::after {\n  transform: rotate(180deg);\n}\n\n.table th {\n  background-color: #f5f5f5;\n  padding: 12px 8px;\n  text-align: left;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n.table td {\n  padding: 12px 8px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n.table tr:hover {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n\n.table tr.detail-row:hover {\n  background-color: #f8f8f8;\n}\n\n@media (max-width: 1024px) {\n  .layout-container {\n    flex-direction: column;\n  }\n  \n  .form-container, .table-container {\n    width: 100%;\n    min-width: unset;\n  }\n  \n  .form-container {\n    margin-bottom: 30px;\n  }\n  \n  .mat-column-id {\n    width: 50px;\n  }\n  \n  .mat-column-actions {\n    width: 100px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
